// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"19":"blog","213":"demo","594":"blog-post","962":"home"}[chunkId] + "." + {"19":"bde48784","213":"1ba135da","594":"188a26e0","962":"012e48a2"}[chunkId] + ".css";
};